interface HexConnectorProps {
  className?: string;
  /** Animation delay in seconds for staggered pulse */
  delay?: number;
}

export function HexConnector({ className = "", delay = 0 }: HexConnectorProps) {
  return (
    <div className={`hex-connector ${className}`}>
      <svg
        aria-hidden="true"
        width="28"
        height="32"
        viewBox="0 0 28 32"
        style={{ overflow: "visible" }}
      >
        <polygon
          className="hex-connector-fill"
          points="14,0 27.12,8 27.12,24 14,32 0.88,24 0.88,8"
          style={delay ? { animationDelay: `${String(delay)}s` } : undefined}
        />
        <polygon
          className="hex-connector-edge"
          points="14,0 27.12,8 27.12,24 14,32 0.88,24 0.88,8"
        />
      </svg>
    </div>
  );
}
